import { CreditCardType } from '@anm/api/modules/subscription';
import getFromCdn from '@anm/helpers/getFromCdn';
import styled, { css } from 'styled-components';

const getIcon = (icon: string) =>
  getFromCdn(`images/icons/credit-card-icons/${icon}.svg`);

const variants: { [key in CreditCardType]: ReturnType<typeof css> } = {
  jcb: css`
    background-image: url(${getIcon('jcb')});
  `,
  visa: css`
    background-image: url(${getIcon('visa')});
  `,
  amex: css`
    background-image: url(${getIcon('amex')});
  `,
  diners: css`
    background-image: url(${getIcon('diners')});
  `,
  maestro: css`
    background-image: url(${getIcon('maestro')});
  `,
  discover: css`
    background-image: url(${getIcon('discover')});
  `,
  mastercard: css`
    background-image: url(${getIcon('mastercard')});
  `
};

const CardBlock = styled.div<{ cardType: CreditCardType }>`
  background-repeat: no-repeat;
  width: 32px;
  height: 20px;
  background-size: contain;
  background-position: center;
  margin-bottom: 20px;

  ${({ cardType }) => variants[cardType]}
`;

export default CardBlock;
